import { createContext } from 'react';

// @ts-ignore
const AnalyticsContext = createContext(null);
AnalyticsContext.displayName = 'Analytics';

export default AnalyticsContext;
